import "client-only";
import useSWR from "swr";
import { fetcher } from "../../utils/fetcher";
function useWarehouseTransferReview(id, params) {
  return useSWR(
    !id
      ? null
      : {
          path: `/api/v1/warehouse-transfers/${id}/preview`,
          method: "GET",
          params,
        },
    fetcher,
    {
      revalidateOnFocus: true,
      revalidateOnMount: true,
    },
  );
}

export default useWarehouseTransferReview;
